export default {
    "title": "Technicals sheets / {{client}}",
    "filters": {
        "materialType": "Type of material",
        "material": "Material",
        "description": "Description",
        "technicalSheetNumber": "AC code",
        "diameter": "Diameter (cm)",
        "height": "Height (mm)",
        "zbot": "Canister",
        "ztap": "Covers",
        "zaux": "Plugs",
        "all": "All"
    },
    "technicalsSheetsHeader": "<0>{{count}}</0> technical sheets found",
    "technicalsSheetsZBotHeader": "<0>{{count}}</0> canisters found",
    "technicalsSheetsZTapHeader": "<0>{{count}}</0> covers found",
    "technicalsSheetsZAuxHeader": "<0>{{count}}</0> plugs found",
    "technicalsSheetsTableColumns": {
        "material": "Material",
        "description": "Description",
        "codeAC": "AC code",
        "packingStandard": "Packing standard",
        "diameter": "Diameter (cm)",
        "height": "Height (mm)",
        "download": "Download (PDF)",
        "selection": "Select"
    },
    "bulkDownload": {
        "button": "Download sheets ({{count}})",
        "selectTitle": "Select all filtered sheets",
        "progress": "Downloading {{current}}/{{total}}...",
        "queued": "Queued, waiting to start the download...",
        "maxLimit": "Maximum of {{max}} sheets per download",
        "success": "{{downloaded}} technical sheets downloaded in a ZIP file",
        "partial": "Download completed: {{downloaded}} sheets included and {{failed}} with error (see errores.txt inside the ZIP)",
        "empty": "No technical sheet could be downloaded"
    },
    "nameCollection": "technicals sheets"
}